module.exports = __webpack_public_path__ + "static/media/instagram-svgrepo-com.40d2976a.svg";